import script from "./ProductPriceCardComponent.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProductPriceCardComponent.vue?vue&type=script&setup=true&lang=ts"

import "./ProductPriceCardComponent.vue?vue&type=style&index=0&id=07c9336a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-07c9336a"]])

export default __exports__